globalThis.backoffice = globalThis.backoffice || {};
backoffice.integrations = backoffice.integrations || {};
backoffice.integrations.voip = backoffice.integrations.voip || {};

backoffice.integrations.voip.Aircall = (function() {
  function Aircall() {}

  Aircall.prototype = {
    startCall: function(calledNumber, numberId, callback) {
      const errorCallback = function(message) {
        new PNotify({icon: 'icon-cross2', title: message, type: 'error'});
      }

      $.post('/voip/aircall/start_call', {called_number: calledNumber, number_id: numberId}, function(response) {
        if(response.code) {
          if(typeof callback == 'function') callback();
        } else {
          errorCallback(response.error);
        }
      }).error(function() {
        errorCallback("Impossible de lancer l'appel");
      });
    },
    initView: function($container) {
      this.$container = $container;
      this.config = this.$container.data('config');
      this.$phoneContainer = this.$container.find('#aircall-phone');
      this.$callContext = this.$container.find('#call-context');
      this.$externalLinks = this.$container.find('#external-links');
      this.$unqualifiedPhoneCalls = this.$container.find('#unqualified-phone-calls');

      this.displayPhone();
      this.initNotesForm();
      this.events();
      this.refreshUnqualifiedPhoneCalls();
    },
    displayPhone: function() {
      const self = this;
      self.phone = new AircallWorkspace({
        domToLoadWorkspace: '#' + self.$phoneContainer.attr('id'),
        size: 'small',
      });

      $.each(['incoming_call', 'outgoing_call'], function() {
        let eventName = this;
        self.phone.on(eventName, function(callInfo) {
          self.ongoingCall = true;
          self.$phoneContainer.find('.call-feedback-modal').hide();
          self._callLoading();
          if(callInfo) {
            self._fetchInterlocutorInfo(eventName, callInfo);
            self._fetchCallContext(callInfo.call_id);
          }
          self.$unqualifiedPhoneCalls.collapse('hide');
        });
      });

      self.phone.on('call_ended', function(callInfo) {
        self.ongoingCall = false;
        self.$unqualifiedPhoneCalls.collapse('show');
      });
    },
    initNotesForm: function() {
      const $notesForm = $('#calls-notes-form');
      const $textarea = $notesForm.find('textarea');
      utils.require([assets.ckeditor], function() {
        const targetId = $textarea.attr('id');
        const editorParams = {
          startupFocus: false,
          enterMode : CKEDITOR.ENTER_BR,
          height: 360,
          skin: 'moono-lisa',
          removePlugins: 'sourcearea,magicline,elementspath',
          toolbar: [
            {
              items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'NumberedList', 'BulletedList', 'HorizontalRule']
            }
          ]
        };
        const editor = CKEDITOR.replace(targetId, editorParams);

        editor.on('instanceReady', function(ev){
          ev.editor.dataProcessor.writer.setRules('br', {
            indent : false,
            breakBeforeOpen : false,
            breakAfterOpen : false,
            breakBeforeClose : false,
            breakAfterClose : false
          });
        })
        editor.on('key', function() {
          $textarea.val(editor.getData());
          $textarea.trigger('keyup');
        });
        editor.on('change', function() {
          $textarea.val(editor.getData());
          $textarea.trigger('change');
        });
      });
    },
    initUpdateContactForm: function() {
      const self = this;

      const $updatePhoneCallContactForm = self.$callContext.find('#update-phone-call-contact-form');
      $updatePhoneCallContactForm.find('[data-popup="tooltip"]').tooltip();
      $updatePhoneCallContactForm.on('submit', function (e) {
        e.preventDefault();

        $.ajax({
          url: $updatePhoneCallContactForm.attr('action'),
          method: 'PATCH',
          data: $updatePhoneCallContactForm.serialize()
        }).done(function (response) {
          if (response.code) {
            self.$callContext.html(response.html.call_context);
            self.initUpdateContactForm();
            self.initQualificationForm();
            new backoffice.Loader().finish();
          } else {
            new PNotify({ icon: 'icon-cross2', title: response.error, type: 'error' });
          }
        }).fail(function () {
          new PNotify({ icon: 'icon-cross2', title: "Erreur serveur", type: 'error' });
        });
      });
    },
    initQualificationForm: function() {
      const self = this;
      const $qualificationForm = self.$callContext.find('#phone-call-qualification-form');
      const $qualificationFormPanel = $qualificationForm.closest('.panel');
      $qualificationFormPanel.find('[data-popup="tooltip"]').tooltip();
      (new backoffice.PhoneCallQualification($qualificationForm)).initForm();
      $qualificationForm.on('submit', function() {
        $qualificationFormPanel.block({
          message: '<i class="icon-spinner3 spinner"></i>',
          overlayCSS: {
            backgroundColor: '#1B2024',
            opacity: 0.5,
            cursor: 'wait'
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: 'none',
            color: '#fff'
          }
        });
        $.post($qualificationForm.attr('action') + '.json', $qualificationForm.serialize(), function(data) {
          if(data.response) {
            if(data.qualified) {
              self._fetchUnqualifiedPhoneCalls();
              $qualificationFormPanel.find('.qualification-status.ongoing').fadeOut('fast', function() {
                $qualificationFormPanel.find('.qualification-status.done').fadeIn('fast');
              });
            }

            $qualificationFormPanel.block({
              message: '<i class="icon-check position-left" style="font-size: 20px;"></i>Appel qualifié',
              overlayCSS: {
                backgroundColor: '#4CAF50',
                opacity: 0.8
              },
              css: {
                width: "80%",
                border: 0,
                padding: 0,
                backgroundColor: 'none',
                color: '#fff',
                fontSize: '20px',
                cursor: 'pointer'
              }
            });
            setTimeout(function() {
              $qualificationFormPanel.unblock();
            }, 5000);
          }
        });

        return false;
      });
    },
    events: function() {
      const self = this;

      $(window).on('beforeunload', function() {
        return 'Etes-vous sûrs de vouloir quitter cette page ?\nCette page est indispensable pour le bon fonctionnement de Aircall';
      });

      self.$container.on('click', '.call', function(e) {
        let $call = $(this);

        self._callLoading();
        $call.block({
          message: '<i class="icon-spinner3 spinner"></i>',
          overlayCSS: {
            backgroundColor: '#1B2024',
            opacity: 0.5,
            cursor: 'wait'
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: 'none',
            color: '#fff'
          }
        });
        self._fetchCallContext($(this).data('call-id'), function() {
          $call.unblock();
        });

        return false;
      });

      self.$container.on('click', '.ajax', function(e) {
        let $this = $(this);

        $.ajax({
          url: `${$this.attr('href')}.json`,
          method: $this.data('method') || 'GET',
        }).done(function(response) {
          if(response.code) {
            new PNotify({icon: 'icon-checkmark3', title: response.message, type: 'success'});
          } else {
            new PNotify({icon: 'icon-cross2', title: response.error, type: 'error'});
          }
        }).fail(function() {
          new PNotify({icon: 'icon-cross2', title: "Erreur serveur", type: 'error'});
        });

        return false;
      });
    },
    refreshUnqualifiedPhoneCalls: function() {
      const self = this;

      setInterval(function() {
        self._fetchUnqualifiedPhoneCalls();
      }, 30000);
    },
    _fetchUnqualifiedPhoneCalls: function() {
      const self = this;
      const $loading = self.$unqualifiedPhoneCalls.closest('.panel').find('.loading');

      $loading.fadeIn('fast');
      self.$unqualifiedPhoneCalls.block({
        overlayCSS: {
          backgroundColor: 'none',
          opacity: 0,
          cursor: 'wait'
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: 'none',
          color: '#fff'
        }
      });
      $.get('/voip/aircall/unqualified_phone_calls', {collapsed: !self.ongoingCall}, function(response) {
        if(response.code) {
          let $html = $(response.html);
          self.$unqualifiedPhoneCalls.replaceWith($html);
          self.$unqualifiedPhoneCalls = $html;
          $loading.fadeOut('fast');
        }
      });
    },
    _fetchCallContext: function(callId, callback) {
      const self = this;

      $.get('/voip/aircall/call_context', {call_id: callId}, function(response) {
        if(response.code) {
          self.$callContext.fadeOut('fast', function() {
            self.$callContext.html(response.html.call_context);
            self.$callContext.find('.has-popover').popover({html: true});
            self.$callContext.find('[data-popup="tooltip"]').tooltip();
            self.initUpdateContactForm();
            self.initQualificationForm();
            new backoffice.ContactQualification($('#contact-qualification-form'));
            self.$callContext.fadeIn('fast');
            backoffice.CustomerPulse.init(self.$callContext);
          });
          self.$externalLinks.fadeOut('fast', function() {
            self.$externalLinks.html(response.html.external_links);
            self.$externalLinks.fadeIn('fast');
            backoffice.CustomerPulse.init(self.$externalLinks);
          });
          if(typeof callback == 'function') callback(response);
        } else {
          setTimeout(function() {
            self._fetchCallContext(callId, callback);
          }, 2000);
        }
      });

    },
    _callLoading: function() {
      this.$callContext.show().block({
        message: '<i class="icon-spinner3 spinner"></i><br>Chargement de l\'appel...',
        overlayCSS: {
          backgroundColor: '#1B2024',
          opacity: 0.5,
          cursor: 'wait'
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: 'none',
          color: '#fff'
        }
      });
      this.$externalLinks.show();
    },
    _fetchInterlocutorInfo: function(callDirection, callInfo) {
      const self = this;
      let phoneNumber;

      if(callDirection == 'incoming_call') {
        phoneNumber = callInfo.from;
      } else {
        phoneNumber = callInfo.to;
      }

      $.get('/voip/aircall/interlocutor_info', {phone_number: phoneNumber, call_direction: callDirection}, function(response) {
        if(response.code) {
          $('.page-header .page-title h4').html(response.page_title);
          self._sendBrowserNotification(response);
        }
      });
    },
    _sendBrowserNotification: function(data) {
      const self = this;

      if (!('Notification' in window)) {
        console.log('Ce navigateur ne supporte pas les notifications de service');
      } else if (Notification.permission === 'granted') {
        self._browserNotification(data);
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission().then(function (permission) {
          if (permission === 'granted') {
            self._browserNotification(data);
          }
        });
      }
    },
    _browserNotification: function(data) {
      let notification = new Notification("Appel en cours", {
        icon: data.assets.image,
        body: data.notification.body
      });
      notification.onclick = function() {
        parent.focus();
        window.focus();
        this.close();
      }
      return notification;
    }
  }

  return Aircall;
})();
